import { CouponStorage } from "./storage.js";

// for test purposes
window.CouponStorage = CouponStorage;
